<template lang="pug">
  v-tooltip(bottom)
    template(v-slot:activator="{ on }")
      div(
        class="block-document-send-date"
        v-on="on"
      )
        e-svg-icon(class="pr-1") clock-play-primary
        div(class="text-12px fw-400 color-primary text-no-wrap") {{ formattedDate }}
    span {{ tooltipText }}
</template>

<script>
export default {
  name: 'BlockDocumentSendDate',
  props: {
    scheduledDate: {
      type: String,
      default: null
    }
  },
  computed: {
    formattedDate() {
      return this.$t('Datetime', {
        date: this.$moment(this.scheduledDate).format('DD.MM'),
        time: this.$moment(this.scheduledDate).format('HH:mm')
      })
    },
    tooltipText() {
      return this.$t('Document will be send automatically at datetime', {
        date: this.$moment(this.scheduledDate).format('DD.MM.YYYY'),
        time: this.$moment(this.scheduledDate).format('HH:mm')
      })
    }
  }
}
</script>

<style scoped lang="scss">
.block-document-send-date {
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 4px 8px;
  border-radius: 20px;
  background: $primary-light;
}
</style>
